import React from "react";
import { Link } from "react-router-dom";
import { Leaf, Mail, Phone, MapPin, MessageCircle } from "lucide-react";
import { BRAND } from "../lib/constants";
import { useSiteSettings } from "../context/SiteSettingsContext";

const Footer = () => {
  const { settings } = useSiteSettings();
  const c = settings?.contact || {};
  return (
    <footer className="bg-[#1F4D2E] text-[#E7E1D3] mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <img src={settings?.logo_url || BRAND.logo} alt="logo" className="h-12 w-12 rounded-full object-cover ring-1 ring-[#C5A059] bg-white" />
            <span className="font-serif font-bold text-lg text-white">Aarmira</span>
          </div>
          <p className="text-sm text-[#B7C4B2] leading-relaxed">
            Premium Ayurvedic & herbal wellness products crafted from nature's finest ingredients and timeless tradition.
          </p>
        </div>
        <div>
          <h4 className="font-serif text-lg text-white mb-4">Shop</h4>
          <ul className="space-y-2 text-sm text-[#B7C4B2]">
            <li><Link to="/shop" className="hover:text-[#C5A059]">All Products</Link></li>
            <li><Link to="/shop?category=juices" className="hover:text-[#C5A059]">Juices</Link></li>
            <li><Link to="/shop?category=skincare" className="hover:text-[#C5A059]">Skin Care</Link></li>
            <li><Link to="/shop?category=wellness" className="hover:text-[#C5A059]">Ayurvedic Wellness</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-serif text-lg text-white mb-4">Company</h4>
          <ul className="space-y-2 text-sm text-[#B7C4B2]">
            <li><Link to="/categories" className="hover:text-[#C5A059]">Categories</Link></li>
            <li><Link to="/terms" className="hover:text-[#C5A059]" data-testid="footer-terms">Terms & Conditions</Link></li>
            <li><Link to="/shipping" className="hover:text-[#C5A059]" data-testid="footer-shipping">Shipping Policy</Link></li>
            <li><Link to="/returns" className="hover:text-[#C5A059]" data-testid="footer-returns">Returns & Refund Policy</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-serif text-lg text-white mb-4">Get in touch</h4>
          <ul className="space-y-3 text-sm text-[#B7C4B2]">
            {c.phone && <li className="flex items-center gap-2" data-testid="footer-phone"><Phone size={16} /> {c.phone}</li>}
            {c.whatsapp && <li className="flex items-center gap-2" data-testid="footer-whatsapp"><MessageCircle size={16} /> {c.whatsapp}</li>}
            {c.email && <li className="flex items-center gap-2" data-testid="footer-email"><Mail size={16} /> {c.email}</li>}
            {c.address && <li className="flex items-center gap-2" data-testid="footer-address"><MapPin size={16} /> {c.address}</li>}
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-xs text-[#9FB09B] flex items-center justify-center gap-2">
        <Leaf size={14} /> © {new Date().getFullYear()} {BRAND.name}. Nature's Power, Your Wellness.
      </div>
    </footer>
  );
};

export default Footer;
